
import posts from '../data/posts';
import { Link } from 'react-router-dom';

function getCategoriesWithPosts(posts) {
  const map = {};
  posts.forEach(post => {
    if (!map[post.category]) map[post.category] = [];
    map[post.category].push(post);
  });
  return map;
}

function Categories() {
  const categories = getCategoriesWithPosts(posts);
  return (
    <div style={{ maxWidth: 700, margin: '40px auto', padding: 24 }}>
      <h2>Categories</h2>
      {Object.keys(categories).length === 0 && <p>No categories found.</p>}
      {Object.entries(categories).map(([cat, posts]) => (
        <div key={cat} style={{ marginBottom: 32 }}>
          <h3 style={{ color: '#2a5d9f', marginBottom: 8 }}>{cat}</h3>
          <ul style={{ marginLeft: 16 }}>
            {posts.map(post => (
              <li key={post.id} style={{ marginBottom: 4 }}>
                <strong>
                  <Link to={`/post/${post.id}`} style={{ color: '#2a5d9f', textDecoration: 'none' }}>
                    {post.title}
                  </Link>
                </strong>
                <span style={{ color: '#888', fontSize: '0.95em', marginLeft: 6 }}>({post.date})</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default Categories;
